

import Component from '../Component';

export default class Localization extends Component {
    constructor(theme, element) {
        super(theme, element);

        this.form = /** @type {HTMLFormElement} */ (this.element.querySelector('.localization-selector-form'));
        if (!this.form) {
            return;
        }

        Array.prototype.forEach.call(
            this.form.querySelectorAll('select'),
            (el) => {
                el.addEventListener('change', this.onSelectChange);
            },
        );
    }

    onSelectChange = () => {
        this.form.submit();
    }
}